import { render, staticRenderFns } from "./RecoveryConfirmed.vue?vue&type=template&id=69648899&scoped=true"
import script from "./RecoveryConfirmed.vue?vue&type=script&lang=js"
export * from "./RecoveryConfirmed.vue?vue&type=script&lang=js"
import style0 from "./RecoveryConfirmed.vue?vue&type=style&index=0&id=69648899&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69648899",
  null
  
)

export default component.exports